<template>
  <egg-description
    title="bivalentVaccine.vaccinePromotion"
    titleColor="#603813"
    textCustomStyle="margin:auto;text-align:center"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg' }"
    :eggImgObj="{ componentName: 'bivalentVaccine', imgName: 'vaccinePromotion', imgFormat: 'svg', position: 'left' }"
    :isShowStarBackgroundRight="false"
    :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconBrownLeft', imgFormat: 'svg', bottom: '-30%' }"
    textMode="text"
    class="pb-24 font-sanstc"
  >
    <template #customSection>
      <div class="text-3xl font-sanstc" style="color: #4e4e4e">{{ t("bivalentVaccine.vaccinePromotionPara1") }}</div>
      <div class="text-5xl font-bold font-sanstc" style="color: #603813">{{ t("bivalentVaccine.vaccinePromotionPara2") }}</div>
      <div class="text-3xl font-sanstc" style="color: #4e4e4e">{{ t("bivalentVaccine.vaccinePromotionPara3") }}</div>
      <div class="text-5xl font-bold font-sanstc" style="color: #603813">{{ t("bivalentVaccine.vaccinePromotionPara4") }}</div>
    </template>
  </egg-description>
</template>

<script setup lang="ts">
import { useBivalentVaccineStore } from "@/stores/bivalentVaccine";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const bivalentVaccineStore = useBivalentVaccineStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>